<template>
  <section class="upload-section mt-2">
    <el-upload
      drag
      action="#"
      multiple
      :headers="uploadHeaders"
      :accept="accept"
      :file-list="fileList"
      :auto-upload="false"
      :on-change="handleChange"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      <span class="fs-11px"><i class="el-icon-info"></i> Files must be 10mb or less</span>
    </el-upload>
    <div class="d-flex gap25 mt-10 mb-10">
      <el-button @click="closeDialog">Cancel</el-button>
      <el-button type="primary" @click="submitFile">Submit</el-button>
    </div>
    <el-table :data="uploadedFiles" stripe class="mt-2" @row-click="downloadDocument">
      <el-table-column prop="name" label="File Name" />
      <el-table-column prop="url" label="File URL" />
    </el-table>
  </section>
  </template>

<script>
import { mapGetters } from 'vuex';
import { fileUploadAccepts } from '@/utils/constants';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    currentMember: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fileList: [],
      uploadedFiles: [],
      fileUploadAccepts,
      fileUpdateUrl: `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/tmp`,
      isUploading: false,
      uploadPercentage: 0,
      dialogVisible: false,
    };
  },
  async mounted() {
    console.log(this.value);
    await this.$http.get(`assemble/api/v1/portal/accreditations/${this.value._id}/members/${this.currentMember._id}/documents`)
      .then((res) => {
        this.uploadedFiles = res.data.documents;
      });
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    },
    downloadDocument(document) {
      const { _id } = document;
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/portal/files/${_id}/signed`)
        .then((res) => {
          this.$store.commit('loading', false);
          window.open(res.data.url, '_blank');
        })
        .catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    beforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    async handleChange(file) {
      if (!this.beforeUpload(file.raw)) return false;

      this.isUploading = true;
      const res = await this.$http.post(
        this.fileUpdateUrl,
        {
          fileName: file.name
        },
        {
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);
          }
        }
      );
      const { url, name, s3Path } = res.data;

      await fetch(url, {
        method: 'PUT',
        body: file.raw,
        headers: { 'Content-Type': '*/*' },
      });

      this.fileList.push({
        name,
        url: s3Path
      });

      this.isUploading = false;

      return true;
    },
    async submitFile() {
      try {
        const response = await this.$http.post(`assemble/api/v1/portal/accreditations/${this.value._id}/members/${this.currentMember._id}/documents`, { fileUploads: this.fileList });
        this.uploadedFiles = response.data.documents;
        this.$message.success('Documents uploaded successfully');
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
  },
  computed: {
    accept() {
      return fileUploadAccepts;
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
};
</script>

  <style lang="scss" scoped>
  .upload-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  </style>
